const state = {
  isReadOnlyCycleModel: false,
};

const getters = {
  isReadOnlyCycleModel: (state) => state.isReadOnlyCycleModel
};

const mutations = {
  setGlobalStatus(state, data = {}) {
    Object.keys(data).forEach(key => {
      if (key in state) {
        state[key] = data[key];
      }
    })
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
